import styled from 'styled-components';

const Form = styled.form`
  input {
    margin-bottom: ${(props) => props.theme.size.baseUnit};
  }

  input.error {
    border: 1px solid ${({ theme }) => theme.color.ui.warning};
  }

  span.error {
    color: ${({ theme }) => theme.color.ui.warning};
    transform: translateY(-6px);
    display: block;
  }
`;

export default Form;
